// import { useForm } from "@mantine/form";
import { useMutation, useQuery } from "@tanstack/react-query";
import { addMatch, getUsers, getMatchStyle, getLevels, getThemes, getAllUsers } from "../../../../api/agent/match";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const useCreate = () => {
    const navigate = useNavigate()
    const createMutation = useMutation({
        mutationFn: addMatch,
        onSuccess: async (response) => {
            try {
                navigate("/agent/match-offers", {
                    replace: true
                })
            } catch (error) {
                console.error(error);
            }
        }
    })

    const ThemeQuery = useQuery({
        queryKey: ["load data theme"],
        queryFn: () => getThemes({
        }),
        select: (res) => {
            if (res?.themes
            ) {

                return res?.themes
                    ?.map((item) => ({
                        label: item?.name,
                        value: item?.id,
                        theme: item,
                        image: item?.image?.url,

                    }))
            } else {
                return []
            }
        }

    });

    const ThemeQuery11 = useQuery({
        queryKey: ["load data theme 11"],
        queryFn: () => getThemes({
        }),
        select: (res) => {
            if (res?.themes
            ) {

                return res?.themes
                    ?.map((item) => ({
                        label: item?.name,
                        value: item?.image?.url,
                        theme: item,
                        image: item?.image?.url,

                    }))
            } else {
                return []
            }
        }

    });



    const LevelQuery = useQuery({
        queryKey: ["load data levels"],
        queryFn: () => getLevels({
        }),
        select: (res) => {
            if (res?.levels
            ) {

                return res?.levels
                    ?.map((item) => ({
                        label: item?.name,
                        value: item?.id,
                        level: item

                    }))
            } else {
                return []
            }
        }

    });

    const userQuery = useQuery({
        queryKey: ["load data get user query"],
        queryFn: () => getUsers({
        }),
        select: (res) => {
            if (res?.users
            ) {

                return res?.users
                    .map((item) => ({
                        label: item,
                        value: item,
                    }))
            } else {
                return []
            }
        }

    });

    const userAllQuery = useQuery({
        queryKey: ["load data get user all query"],
        queryFn: () => getAllUsers({
        }),
        select: (res) => {
            console.log({ res });

            if (res?.users
            ) {

                let data = []
                Object.keys(res?.users).forEach((key) => {
                    data.push(
                        {
                            label: res.users[key],
                            value: res.users[key]
                        }
                    )
                });
                return data
                // return res?.users
                //     .map((item) => ({
                //         label: item,
                //         value: item,
                //     }))
            } else {
                return []
            }
        }

    });


    const matchStyleQuery = useQuery({
        queryKey: ["load data get match style query"],
        queryFn: () => getMatchStyle({
        }),
        select: (res) => {
            if (res?.match_style
            ) {

                return res?.match_style
                    .map((item) => ({
                        label: item.name,
                        value: item.id,
                    }))
            } else {
                return []
            }
        }

    });

    // const countryQuery = useQuery({
    //     queryKey: ["load data get country query"],
    //     queryFn: () => axios.get(`https://restcountries.com/v3.1/all?fields=name,flag`),
    //     select: (res) => {
    //         if (res.data
    //         ) {

    //             return res.data
    //                 .map((item) => ({

    //                     label: item.flag + ' ' + item.name.common,
    //                     value: item.name.common,
    //                 }))

    //         } else {
    //             return []
    //         }
    //     }

    // });


    return { createMutation, ThemeQuery, LevelQuery, userQuery, matchStyleQuery, userAllQuery, ThemeQuery11 }

}

export default useCreate;
